import { Component, OnInit } from '@angular/core';
import { PublicService } from '../api/public.service';
import { AutorizationService } from '../api/autorization.service';



@Component({
  selector: 'app-test-api-call',
  templateUrl: './test-api-call.component.html',
  styleUrls: ['./test-api-call.component.less']
})
export class TestApiCallComponent implements OnInit {

  constructor(private publicApiService : PublicService, private autorizationService :AutorizationService) { }

  apiResult = null;


  ngOnInit() {
  }

  getPasswordToken() {

  }

  callGetStation() : void {
  }   

}
